var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewbox":_vm.viewbox},domProps:{"innerHTML":_vm._s(_vm.gauge)}})}
var staticRenderFns = []

export { render, staticRenderFns }